import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

function AdminPages() {
  const [pages, setPages] = useState([]);
  const [editingPage, setEditingPage] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    loadPages();
  }, []);

  const loadPages = () => {
    apiService.getPages()
      .then(response => setPages(response.data.pages))
      .catch(error => console.error('Error loading pages:', error));
  };

  const handleSave = (e) => {
    e.preventDefault();
    apiService.updatePage(editingPage, token)
      .then(() => {
        loadPages();
        setEditingPage(null);
        alert('Page updated successfully!');
      })
      .catch(error => console.error('Error updating page:', error));
  };

  if (editingPage) {
    return (
      <div>
        <h2>Edit Page: {editingPage.title}</h2>
        <div className="admin-card">
          <form onSubmit={handleSave} className="admin-form">
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                value={editingPage.title}
                onChange={(e) => setEditingPage({...editingPage, title: e.target.value})}
              />
            </div>
            
            <div className="form-group">
              <label>Content</label>
              <textarea
                value={editingPage.content}
                onChange={(e) => setEditingPage({...editingPage, content: e.target.value})}
                rows="10"
              />
            </div>
            
            <div className="form-group">
              <label>Meta Description</label>
              <input
                type="text"
                value={editingPage.meta_description || ''}
                onChange={(e) => setEditingPage({...editingPage, meta_description: e.target.value})}
              />
            </div>
            
            <button type="submit" className="btn-save">Save Changes</button>
            <button 
              type="button" 
              className="btn-admin" 
              onClick={() => setEditingPage(null)}
              style={{marginLeft: '10px'}}
            >
              Cancel
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2>Page Management</h2>
      
      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Slug</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pages.map(page => (
              <tr key={page.id}>
                <td>{page.title}</td>
                <td>{page.slug}</td>
                <td>{page.is_published ? 'Published' : 'Draft'}</td>
                <td>
                  <button className="btn-admin btn-edit" onClick={() => setEditingPage(page)}>
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminPages;
